var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIconBrandDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1314_883436",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1314_883436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info_2",
    d: "M8.99394 12.7588C9.22906 12.7588 9.4275 12.6789 9.58925 12.519C9.751 12.3591 9.83187 12.1611 9.83187 11.9248V8.93383C9.83187 8.69758 9.75231 8.49951 9.59319 8.33964C9.43406 8.17976 9.23694 8.09983 9.00181 8.09983C8.76669 8.09983 8.56825 8.17976 8.4065 8.33964C8.24475 8.49951 8.16388 8.69758 8.16388 8.93383V11.9248C8.16388 12.1611 8.24344 12.3591 8.40256 12.519C8.56169 12.6789 8.75881 12.7588 8.99394 12.7588ZM8.99394 6.9617C9.24406 6.9617 9.45506 6.87714 9.62694 6.70802C9.79881 6.53877 9.88475 6.32902 9.88475 6.07877C9.88475 5.82864 9.80019 5.61764 9.63106 5.44577C9.46181 5.27389 9.25206 5.18795 9.00181 5.18795C8.75169 5.18795 8.54069 5.27251 8.36881 5.44164C8.19694 5.61089 8.111 5.82064 8.111 6.07089C8.111 6.32101 8.19556 6.53201 8.36469 6.70389C8.53394 6.87576 8.74369 6.9617 8.99394 6.9617ZM9.00312 16.5602C7.95562 16.5602 6.97319 16.3636 6.05581 15.9703C5.13856 15.5771 4.33619 15.0366 3.64869 14.349C2.96106 13.6615 2.42062 12.8594 2.02737 11.9426C1.63412 11.0259 1.4375 10.0421 1.4375 8.9912C1.4375 7.94045 1.63412 6.95952 2.02737 6.04839C2.42062 5.13739 2.96106 4.33814 3.64869 3.65064C4.33619 2.96302 5.13831 2.42258 6.05506 2.02933C6.97181 1.63608 7.95562 1.43945 9.0065 1.43945C10.0573 1.43945 11.0382 1.63608 11.9493 2.02933C12.8603 2.42258 13.6596 2.96302 14.3471 3.65064C15.0347 4.33814 15.5751 5.13883 15.9684 6.0527C16.3616 6.96658 16.5582 7.9472 16.5582 8.99458C16.5582 10.0421 16.3616 11.0245 15.9684 11.9419C15.5751 12.8591 15.0347 13.6615 14.3471 14.349C13.6596 15.0366 12.8589 15.5771 11.945 15.9703C11.0311 16.3636 10.0505 16.5602 9.00312 16.5602Z",
    fill: "#6C53E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconBrandDark);
export default __webpack_public_path__ + "static/media/info-icon-brand-dark.15d465f701167ded04d9c4bc1471ebb4.svg";
export { ForwardRef as ReactComponent };